import {useEffect} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {Link} from 'react-router-dom'

import {useDispatch} from 'react-redux'
import { SucursalHorarioList } from './Components/SucursalHorarioList'
import { gu_hs_getHorariosEmpresa } from '../../../actions/gestion-usuario/horarios/horarios.actions'
import { FormHorario } from './Components/FormHorario'

const Horarios = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(gu_hs_getHorariosEmpresa());
    window.scroll(0, 0)
  }, [])

  return (
    <BasicLayout>
      <div className='header'>
        <Link to='/gestion-usuarios' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles'>Horarios de atención</h3>
      </div>
      <div className='separador'></div>
      <SucursalHorarioList />
      <FormHorario />
    </BasicLayout>
  )
}

export default Horarios
